import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  SupportRecord,
  SupportRecordService,
} from 'src/app/private/services/support-record.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { LeadActivityFeedItem } from '../lead-activity-feed/lead-activity-feed.component';

const SUPPORT_TYPE_LABELS: Record<string, string> = {
  live_chat: 'Live Chat',
  phone_call: 'Phone Call',
  email: 'Email',
  ticket: 'Ticket',
  whatsapp: 'WhatsApp',
};

@Component({
  selector: 'app-lead-profile-support',
  templateUrl: './lead-profile-support.component.html',
  styleUrls: ['./lead-profile-support.component.scss'],
})
export class LeadProfileSupportComponent implements OnChanges {
  @Input() leadId: number | string | null = null;
  @Input() refreshToken = 0;

  items: LeadActivityFeedItem[] = [];
  loading = false;
  total = 0;

  constructor(
    private supportRecords: SupportRecordService,
    private localStorage: LocalStorageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['leadId'] || changes['refreshToken']) {
      this.load();
    }
  }

  load(): void {
    if (this.leadId == null || this.leadId === '') {
      this.items = [];
      this.total = 0;
      return;
    }

    this.loading = true;
    this.supportRecords
      .getSupportRecords({
        client_id: this.localStorage.getClientId(),
        lead_id: this.leadId,
        page: 0,
        limit: 50,
      })
      .subscribe({
        next: (res) => {
          const rows = res?.records ?? [];
          this.total = res?.total ?? rows.length;
          this.items = rows.map((row) => this.toFeedItem(row));
          this.loading = false;
        },
        error: () => {
          this.items = [];
          this.total = 0;
          this.loading = false;
        },
      });
  }

  private toFeedItem(row: SupportRecord): LeadActivityFeedItem {
    const typeLabel = this.supportTypeLabel(row.support_type);
    const parts: string[] = [];

    if (row.subject) {
      parts.push(`Subject: ${row.subject}`);
    }
    if (row.agent_name) {
      parts.push(`Agent: ${row.agent_name}`);
    }

    const meta = row.metadata;
    if (meta && typeof meta === 'object') {
      const notes = meta['notes'];
      if (notes) {
        parts.push(String(notes));
      }
    }

    return {
      id: row.id,
      actorName: typeLabel,
      createdAt: row.createdAt || row.updatedAt || '',
      body: parts.length ? parts.join(' · ') : 'No details recorded',
      raw: row,
    };
  }

  private supportTypeLabel(type: string | null | undefined): string {
    const key = String(type || '').trim().toLowerCase();
    if (!key) {
      return 'Support';
    }
    if (SUPPORT_TYPE_LABELS[key]) {
      return SUPPORT_TYPE_LABELS[key];
    }
    return key
      .split('_')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }
}
